import { FlatMultiValuedList } from '../../../Flat'
import { ListCell } from '../ListCell'

function TableFlatListCell({ List = FlatMultiValuedList, ...restProps }) {
  return <ListCell {...restProps} List={List} />
}

export default TableFlatListCell
